import React from 'react';

class FulfillmentTable extends React.Component {
    
    getQuantityColor(quantity) {
        if (quantity <= 5) {
            return { bg: '#E7CC49BF', text: '#000000' };
        } else if (quantity <= 20) {
            return { bg: '#EF8C8CA6', text: '#000000' };
        } else if (quantity <= 50) {
            return { bg: '#E57373', text: '#FFFFFF' };
        } else if (quantity <= 80) {
            return { bg: '#EF5350', text: '#FFFFFF' };
        } else if (quantity <= 100) {
            return { bg: '#F44336', text: '#FFFFFF' };
        } else {
            return { bg: '#C62828', text: '#FFFFFF' };
        }
    }

    renderLoader() {
        return (
            <div className="picking-progress-loader">
                <div className="picking-progress-content">
                    <i className="fas fa-box-open picking-progress-icon"></i>
                    <h3 className="picking-progress-title">{this.props.loadingTitle || 'Loading Data'}</h3>
                    <p className="picking-progress-subtitle">
                        <span className="picking-progress-spinner"></span>
                        {this.props.loadingSubtitle || 'Fetching data...'}
                    </p>
                    <div className="picking-progress-bar-container">
                        <div className="picking-progress-bar"></div>
                    </div>
                    <p className="picking-progress-tips">
                        {this.props.loadingTip || 'This may take a few seconds'}
                    </p>
                </div>
            </div>
        );
    }

    renderError(errorMessage) {
        const { onRefresh } = this.props;
        return (
            <div className="picking-empty-state">
                <i className="fas fa-exclamation-circle picking-empty-icon" style={{ color: '#f44336' }}></i>
                <h3 className="picking-empty-title">Error Loading Data</h3>
                <p className="picking-empty-subtitle">{errorMessage}</p>
                {onRefresh && (
                    <button 
                        onClick={onRefresh}
                        className="picking-table-refresh-btn"
                        style={{ marginTop: '15px' }}
                    >
                        <i className="fas fa-sync-alt"></i> Retry
                    </button>
                )}
            </div>
        );
    }

    renderEmptyState() {
        const { onRefresh } = this.props;
        return (
            <div className="picking-empty-state">
                <i className="fas fa-inbox fa-3x picking-empty-icon"></i>
                <h3 className="picking-empty-title">{this.props.emptyTitle || 'No data available'}</h3>
                <p className="picking-empty-subtitle">{this.props.emptySubtitle || 'No fulfillment items available'}</p>
                {onRefresh && (
                    <button 
                        onClick={onRefresh}
                        className="picking-table-refresh-btn"
                        style={{ marginTop: '15px' }}
                    >
                        <i className="fas fa-sync-alt"></i> Refresh
                    </button>
                )}
            </div>
        );
    }

    render() {
        const { 
            data, 
            isLoading, 
            error, 
            onRefresh,
            title = 'Fulfillment Available',
            displayLimit = 10,
            sortByKey = 'totalLeftQty',
            sortOrder = 'desc'
        } = this.props;

        if (isLoading) {
            return this.renderLoader();
        }

        if (error) {
            return this.renderError(error);
        }

        if (!data || !data.length) {
            return this.renderEmptyState();
        }

        // Sort data
        const sortedData = data.slice().sort(function(a, b) {
            if (sortOrder === 'desc') {
                return b[sortByKey] - a[sortByKey];
            }
            return a[sortByKey] - b[sortByKey];
        });

        // Limit display
        const displayData = sortedData.slice(0, displayLimit);
        const hasMoreItems = sortedData.length > displayLimit;

        return (
            <div className="picking-table-container">
                <div className="picking-table-header">
                    <div>
                        <h3 className="picking-table-title">{title}</h3>
                        <span className="picking-table-subtitle">
                            {hasMoreItems ? (
                                <span>
                                    Showing top <strong>{displayLimit}</strong> of <strong>{data.length}</strong> items with highest quantity
                                </span>
                            ) : (
                                <span>{data.length} item(s) available</span>
                            )}
                        </span>
                    </div>
                    {onRefresh && (
                        <button 
                            onClick={onRefresh}
                            className="picking-table-refresh-btn"
                        >
                            <i className="fas fa-sync-alt"></i> Refresh
                        </button>
                    )}
                </div>
                
                <div style={{ overflowX: 'auto' }}>
                    <table className="picking-table">
                        <thead className="picking-table-header-row">
                            <tr>
                                <th className="picking-table-header-cell" style={{ textAlign: 'left', width: '15vw'}}>JPIN</th>
                                <th className="picking-table-header-cell" style={{ textAlign: 'left', width: '40vw'}}>Title</th>
                                <th className="picking-table-header-cell" style={{ textAlign: 'left', width: '15vw'}}>Display Name</th>
                                <th className="picking-table-header-cell" style={{ textAlign: 'center', width: '15vw' }}>Total Left Qty</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayData.map((item, index) => {
                                const quantityColor = this.getQuantityColor(item.totalLeftQty);
                                const isEvenRow = index % 2 === 0;
                                return (
                                    <tr 
                                        key={index} 
                                        className="picking-table-row"
                                        style={{ backgroundColor: isEvenRow ? '#fafafa' : '#ffffff' }}
                                    >
                                        <td 
                                            className={'picking-product-cell ' + (isEvenRow ? 'picking-product-cell-even' : 'picking-product-cell-odd')}
                                        >
                                            <div className="picking-product-content">
                                                <div className="picking-product-icon-badge">
                                                    <i className="fas fa-barcode picking-product-icon"></i>
                                                </div>
                                                <div className="picking-product-info">
                                                    <div className="picking-product-title">
                                                        {item.jpin}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td 
                                            className={'picking-product-cell ' + (isEvenRow ? 'picking-product-cell-even' : 'picking-product-cell-odd')}
                                            style={{ 
                                                borderLeft: '4px solid ' + (quantityColor.bg || '#e0e0e0')
                                            }}
                                        >
                                            <div className="picking-product-content">
                                                <div className="picking-product-info">
                                                    <div className="picking-product-title">
                                                        {item.title}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td 
                                            className={'picking-product-cell ' + (isEvenRow ? 'picking-product-cell-even' : 'picking-product-cell-odd')}
                                        >
                                            <div className="picking-product-content">
                                                <div className="picking-product-info">
                                                    <div className="picking-product-title">
                                                        {item.displayName}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td 
                                            className="picking-quantity-cell"
                                            style={{ 
                                                backgroundColor: quantityColor.bg,
                                                color: quantityColor.text
                                            }}
                                        >
                                            {item.totalLeftQty}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default FulfillmentTable;



// WEBPACK FOOTER //
// ./src/commons/FulfillmentTable.js